import { Fragment, useState, useEffect, useRef, useMemo } from "react";
import { Dialog, Transition } from "@headlessui/react";
import {
  sendPostRequest,
  useGetRequest,
  sendPostRequestMultipart,
} from "../../Client";
import { useMutation } from "@tanstack/react-query";
import { imageURL } from "../../config";

export default function CustomerInventoryUpdate(props) {
  let customerID = props.customerID;

  const [division, setDivision] = useState(false);

  const currentDivisionID = division || props.divisionID;

  const [category1, setCategory1] = useState(false);
  const [category2, setCategory2] = useState(false);
  const [category3, setCategory3] = useState(false);

  const { status: statusDropdownCategories1, data: dataDropdownCategories1 } =
    useGetRequest(`categories/parent/${currentDivisionID}/1`, {});

  const { status: statusDropdownCategories2, data: dataDropdownCategories2 } =
    useGetRequest(`categories/parent/${currentDivisionID}/2`, {});

  const { status: statusDropdownCategories3, data: dataDropdownCategories3 } =
    useGetRequest(`categories/parent/${currentDivisionID}/3`, {});

  const { status: statusTypePiece, data: dataTypePiece } = useGetRequest(
    "inventory/typepiece/" + customerID,
    {},
  );

  const [locations, setLocations] = useState([]);

  useEffect(() => {
    const all2 = dataDropdownCategories2?.categoriesParent ?? [];
    if (!category1) {
      if (category2) {
        setCategory2(0);
        setCategory3(0);
      }
      return;
    }
    const allowed2 = all2.filter(
      (c) => Number(c.parentCategory) === Number(category1),
    );
    const stillValid = allowed2.some(
      (c) => Number(c.categoryID) === Number(category2),
    );
    if (!stillValid) {
      setCategory2(0);
      setCategory3(0);
    }
  }, [category1, dataDropdownCategories2]);

  useEffect(() => {
    const all3 = dataDropdownCategories3?.categoriesParent ?? [];
    if (!category2) {
      if (category3) setCategory3(0);
      return;
    }
    const allowed3 = all3.filter(
      (c) => Number(c.parentCategory) === Number(category2),
    );
    const stillValid = allowed3.some(
      (c) => Number(c.categoryID) === Number(category3),
    );
    if (!stillValid) setCategory3(0);
  }, [category2, dataDropdownCategories3]);

  const cat2Options = useMemo(() => {
    const all = dataDropdownCategories2?.categoriesParent ?? [];
    if (!category1) return [];
    return all.filter((c) => Number(c.parentCategory) === Number(category1));
  }, [dataDropdownCategories2, category1]);

  const cat3Options = useMemo(() => {
    const all = dataDropdownCategories3?.categoriesParent ?? [];
    if (!category2) return [];
    return all.filter((c) => Number(c.parentCategory) === Number(category2));
  }, [dataDropdownCategories3, category2]);

  function getCheckedLocation(value) {
    if (locations?.includes(value)) {
      return true;
    } else {
      return false;
    }
  }

  function formatDate(dateString) {
    if (!dateString) return "";
    const date = new Date(dateString);
    return date.toLocaleDateString("en-GB", {
      day: "numeric",
      month: "long",
      year: "numeric",
    });
  }

  function addRemoveLocation(value) {
    // const locationValue = Number(value);
    const locationValue = value;
    if (locationValue) {
      if (locations?.includes(value)) {
        const locationWithoutThisValue = locations?.filter((x) => x != value);
        setLocations(locationWithoutThisValue);
      } else {
        setLocations([...locations, value]);
      }
    }
  }

  function setInitialLocations(locations) {
    if (locations) {
      return locations.split(",");
    } else {
      return [];
    }
  }

  const { status: statusLocations, data: dataLocations } = useGetRequest(
    "locations",
    {},
  );

  // updating
  const [productCode, setProductCode] = useState();
  const [productDescription, setProductDescription] = useState();
  const [productDescription2, setProductDescription2] = useState();
  const [HSSCode, setHSSCode] = useState();
  const [productCategory, setProductCategory] = useState();
  const [productUnitPrice, setProductUnitPrice] = useState();
  const [adminOnly, setAdminOnly] = useState(undefined);
  const [image, setImage] = useState();
  const [deleteImage, setDeleteImage] = useState(false);
  const [image2, setImage2] = useState();
  const [deleteImage2, setDeleteImage2] = useState(false);

  const [min, setMin] = useState();
  const [max, setMax] = useState();
  const [lowPoint, setLowPoint] = useState();
  const [lowPoint2, setLowPoint2] = useState();
  const [typePiece, setTypePiece] = useState();
  const [offWeb, setOffWeb] = useState();
  const [unitCount, setUnitCount] = useState();
  const [price2, setPrice2] = useState();
  const [productStatus, setProductStatus] = useState();
  const [defaultLocation, setDefaultLocation] = useState();
  const [pending, setPending] = useState(false);
  const [pending2, setPending2] = useState(false);

  const { status, data } = useGetRequest(
    "inventory/details/" + props.productInventoryID,
  );

  const didInit = useRef(false);

  useEffect(() => {
    if (!data?.data || didInit.current) return;

    setProductCode(data?.data?.productCode);
    setProductDescription(data?.data?.description);
    setProductDescription2(data?.data?.description2);
    setHSSCode(data?.data?.HSSCode);
    setProductUnitPrice(data?.data?.unitPrice);
    setAdminOnly(data?.data?.adminOnly);
    setImage(data?.data?.image);
    setImage2(data?.data?.image2);
    setProductCategory(props.productTypeCode);
    setDivision(data?.data?.division);
    setCategory1(data?.data?.category1);
    setCategory2(data?.data?.category2);
    setCategory3(data?.data?.category3);
    setMin(data?.data?.min);
    setMax(data?.data?.max);
    setLowPoint(data?.data?.lowPoint);
    setLowPoint2(data?.data?.lowPoint2);
    setTypePiece(data?.data?.typePiece);
    setOffWeb(data?.data?.offWeb);
    setUnitCount(data?.data?.unitCount);
    setPrice2(data?.data?.price2);
    setProductStatus(data?.data?.productStatus);
    setDefaultLocation(data?.data?.defaultLocation);
    setLocations(setInitialLocations(data?.data?.defaultLocation));

    didInit.current = true;
  }, [data]);

  // updating inventory
  const updateInventory = async (path, body) => {
    const res = await sendPostRequestMultipart(path, body);
    props.updatedNotyf();
  };

  const { mutateAsync: doUpdateMutation } = useMutation({
    mutationFn: (data) => {
      return updateInventory(data.path, { customerID, ...data.body });
    },
    onSuccess: () => {
      props.queryClient.invalidateQueries({ queryKey: ["inventory"] });
    },
  });

  const hasCat1 =
    statusDropdownCategories1 === "fetched" &&
    (dataDropdownCategories1?.categoriesParent?.length ?? 0) > 0;

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (hasCat1 && (!category1 || Number(category1) === 0)) {
      alert("Please select a category 1");
      return;
    }

    const payload = {
      inventoryID: props.productInventoryID,
      productCode,
      productDescription,
      productDescription2,
      HSSCode,
      productUnitPrice,
      adminOnly,
      typeCode: productCategory,
      image,
      deleteImage: deleteImage ? 1 : 0,
      image2,
      deleteImage2: deleteImage2 ? 1 : 0,
      division: Number(currentDivisionID),
      category1: Number(category1) || 0,
      category2: Number(category2) || 0,
      category3: Number(category3) || 0,
      min,
      max,
      lowPoint,
      lowPoint2,
      typePiece,
      offWeb,
      unitCount,
      price2,
      productStatus,
      defaultLocation: locations.length > 0 ? locations : defaultLocation,
    };

    try {
      await doUpdateMutation({ path: "inventory/update", body: payload });
      props.setEditOpen(false);
      setTimeout(() => {
        window.location.reload(false);
      }, 500);
    } catch (err) {
      console.error(err);
      alert("Update failed. Please try again.");
    }
  };

  if (
    data?.data?.productCode &&
    status == "fetched" &&
    statusDropdownCategories1 == "fetched" &&
    statusDropdownCategories2 == "fetched" &&
    statusDropdownCategories3 == "fetched"
  ) {
    return (
      <Transition.Root show={props.editOpen} as={Fragment}>
        <Dialog as="div" className="relative z-10" onClose={props.setEditOpen}>
          <Transition.Child
            as={Fragment}
            enter="ease-in-out duration-500"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in-out duration-500"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
          </Transition.Child>

          <div className="fixed inset-0 overflow-hidden">
            <div className="absolute inset-0 overflow-hidden">
              <div className="pointer-events-none fixed inset-y-0 right-0 flex max-w-full pl-10">
                <Transition.Child
                  as={Fragment}
                  enter="transform transition ease-in-out duration-500 sm:duration-700"
                  enterFrom="translate-x-full"
                  enterTo="translate-x-0"
                  leave="transform transition ease-in-out duration-500 sm:duration-700"
                  leaveFrom="translate-x-0"
                  leaveTo="translate-x-full"
                >
                  <Dialog.Panel className="pointer-events-auto w-screen max-w-4xl">
                    <div className="flex h-full flex-col overflow-y-scroll bg-white shadow-xl">
                      <div className="flex-1 overflow-y-auto px-4 py-6 sm:px-6">
                        <div className="flex items-center justify-between">
                          <Dialog.Title className="text-lg font-medium text-gray-900"></Dialog.Title>
                          <div className="ml-3 flex h-7 items-center">
                            <button
                              type="button"
                              className="-m-2 p-2 text-gray-400 hover:text-gray-500"
                              onClick={() => props.setEditOpen(false)}
                            ></button>
                          </div>
                        </div>

                        <form onSubmit={handleSubmit}>
                          <div className="grid grid-cols-2 gap-x-8 gap-y-4 mt-10">
                            {/* Repeat this block for each label/input pair */}
                            <div className="flex items-center gap-4">
                              <label
                                htmlFor="code"
                                className="w-24 text-sm font-medium text-gray-600"
                              >
                                Product Code
                              </label>
                              <input
                                type="text"
                                name="code"
                                id="code"
                                value={productCode ?? ""}
                                onChange={(e) => setProductCode(e.target.value)}
                                className="flex-1 rounded-md border border-gray-300 py-1.5 px-2 text-sm text-gray-700 shadow-sm focus:border-indigo-500 focus:ring-indigo-500"
                              />
                            </div>

                            <div className="flex items-center gap-4">
                              <label
                                htmlFor="productStatus"
                                className="w-24 text-sm font-medium text-gray-600"
                              >
                                Status
                              </label>
                              <select
                                id="productStatus"
                                name="productStatus"
                                onChange={(e) =>
                                  setProductStatus(e.target.value)
                                }
                                className="flex-1 rounded-md border border-gray-300 py-1.5 px-2 text-sm text-gray-700 shadow-sm focus:border-indigo-500 focus:ring-indigo-500"
                              >
                                <option value={productStatus}>
                                  {productStatus}
                                </option>
                                <option value=""></option>
                                <option value="DISC">DISC</option>
                                <option value="HOLD">HOLD</option>
                              </select>
                            </div>

                            <div className="flex items-center gap-4">
                              <label
                                htmlFor="description"
                                className="w-40 text-sm font-medium text-gray-600"
                              >
                                Description
                              </label>
                              <input
                                type="text"
                                name="description"
                                id="description"
                                value={productDescription ?? ""}
                                onChange={(e) =>
                                  setProductDescription(e.target.value)
                                }
                                className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                              />
                            </div>

                            <div className="flex items-center gap-4">
                              <label
                                htmlFor="description2"
                                className="w-40 text-sm font-medium text-gray-600"
                              >
                                Description 2
                              </label>
                              <input
                                type="text"
                                name="description2"
                                id="description2"
                                value={productDescription2 ?? ""}
                                onChange={(e) =>
                                  setProductDescription2(e.target.value)
                                }
                                className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                              />
                            </div>

                            <div className="flex items-center gap-4">
                              <label
                                htmlFor="HSSCode"
                                className="w-40 text-sm font-medium text-gray-600"
                              >
                                HSS Code
                              </label>
                              <input
                                type="text"
                                name="HSSCode"
                                id="HSSCode"
                                value={HSSCode ? HSSCode : ""}
                                onChange={(e) => {
                                  setHSSCode(e.target.value);
                                }}
                                className="block w-full rounded-md border-0 py-1.5 text-gray-500 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                              />
                            </div>

                            <div className="flex items-center gap-4">
                              <label
                                htmlFor="unitPrice"
                                className="w-40 text-sm font-medium text-gray-600"
                              >
                                Price
                              </label>
                              <input
                                type="text"
                                name="unitPrice"
                                id="unitPrice"
                                value={productUnitPrice ? productUnitPrice : ""}
                                onChange={(e) => {
                                  setProductUnitPrice(e.target.value);
                                }}
                                className="block w-full rounded-md border-0 py-1.5 text-gray-500 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                              />
                            </div>

                            <div className="flex items-center gap-4">
                              <label
                                htmlFor="description"
                                className="w-40 text-sm font-medium text-gray-600"
                              >
                                Division
                              </label>
                              <select
                                id="division"
                                name="division"
                                value={division ?? Number(props.divisionID)}
                                onChange={(e) => {
                                  const next = Number(e.target.value);
                                  if (next !== division) {
                                    setDivision(next);
                                    setCategory1(0);
                                    setCategory2(0);
                                    setCategory3(0);
                                  }
                                }}
                                className="mt-2 block w-full rounded-md border-0 py-1.5 text-gray-500 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:max-w-xs sm:text-sm sm:leading-6"
                              >
                                {/* current division as the first visible option */}
                                <option value={props.divisionID}>
                                  {props.divisionName}
                                </option>
                                {props.dataDropdownDivisions?.divisions.map(
                                  (d) => (
                                    <option
                                      key={d.divisionID}
                                      value={d.divisionID}
                                    >
                                      {d.divisionName}
                                    </option>
                                  ),
                                )}
                              </select>
                            </div>

                            <div className="flex items-center gap-4">
                              <label
                                htmlFor="price2"
                                className="w-40 text-sm font-medium text-gray-600"
                              >
                                Price 2
                              </label>
                              <input
                                type="text"
                                name="price2"
                                id="price2"
                                value={price2 ? price2 : ""}
                                onChange={(e) => {
                                  setPrice2(e.target.value);
                                }}
                                className="block w-full rounded-md border-0 py-1.5 text-gray-500 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                              />
                            </div>

                            <div className="flex items-center gap-4">
                              <label
                                htmlFor="category1"
                                className="w-40 text-sm font-medium text-gray-600"
                              >
                                Category 1
                              </label>
                              <select
                                id="category1"
                                name="category1"
                                value={Number(category1) || 0}
                                onChange={(e) =>
                                  setCategory1(Number(e.target.value))
                                }
                                disabled={
                                  !dataDropdownCategories1?.categoriesParent
                                    ?.length
                                }
                                className="block w-full rounded-md border-0 py-1.5 text-gray-500 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:max-w-xs sm:text-sm sm:leading-6"
                              >
                                <option value={0}></option>
                                {dataDropdownCategories1?.categoriesParent?.map(
                                  (c) => (
                                    <option
                                      key={c.categoryID}
                                      value={c.categoryID}
                                    >
                                      {c.categoryName}
                                    </option>
                                  ),
                                )}
                              </select>
                            </div>

                            <div className="flex items-center gap-4">
                              <label
                                htmlFor="min"
                                className="w-40 text-sm font-medium text-gray-600"
                              >
                                Min
                              </label>
                              <input
                                type="text"
                                name="min"
                                id="min"
                                value={min ? min : ""}
                                onChange={(e) => {
                                  setMin(e.target.value);
                                }}
                                className="block w-full rounded-md border-0 py-1.5 text-gray-500 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                              />
                            </div>

                            <div className="flex items-center gap-4">
                              <label
                                htmlFor="category2"
                                className="w-40 text-sm font-medium text-gray-600"
                              >
                                Category 2
                              </label>
                              {/* <select
                                id="category2"
                                name="category2"
                                value={Number(category2) || 0}
                                onChange={(e) =>
                                  setCategory2(Number(e.target.value))
                                }
                                disabled={
                                  !dataDropdownCategories2?.categoriesParent
                                    ?.length
                                }
                                className="block w-full rounded-md border-0 py-1.5 text-gray-500 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:max-w-xs sm:text-sm sm:leading-6"
                              >
                                <option value={0}></option>
                                {dataDropdownCategories2?.categoriesParent?.map(
                                  (c) => (
                                    <option
                                      key={c.categoryID}
                                      value={c.categoryID}
                                    >
                                      {c.categoryName}
                                      {c.parentCategoryName
                                        ? ` / ${c.parentCategoryName}`
                                        : ""}
                                    </option>
                                  )
                                )}
                              </select> */}
                              <select
                                id="category2"
                                name="category2"
                                value={Number(category2) || 0}
                                onChange={(e) =>
                                  setCategory2(Number(e.target.value))
                                }
                                disabled={
                                  !category1 || cat2Options.length === 0
                                }
                                className="block w-full rounded-md border-0 py-1.5 text-gray-500 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:max-w-xs sm:text-sm sm:leading-6"
                              >
                                <option value={0}></option>
                                {cat2Options.map((c) => (
                                  <option
                                    key={c.categoryID}
                                    value={c.categoryID}
                                  >
                                    {c.categoryName}
                                    {c.parentCategoryName
                                      ? ` / ${c.parentCategoryName}`
                                      : ""}
                                  </option>
                                ))}
                              </select>
                            </div>

                            <div className="flex items-center gap-4">
                              <label
                                htmlFor="max"
                                className="w-40 text-sm font-medium text-gray-600"
                              >
                                Max
                              </label>
                              <input
                                type="text"
                                name="max"
                                id="max"
                                value={max ? max : ""}
                                onChange={(e) => {
                                  setMax(e.target.value);
                                }}
                                className="block w-full rounded-md border-0 py-1.5 text-gray-500 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                              />
                            </div>

                            <div className="flex items-center gap-4">
                              <label
                                htmlFor="category3"
                                className="w-40 text-sm font-medium text-gray-600"
                              >
                                Category 3
                              </label>
                              {/* <select
                                id="category3"
                                name="category3"
                                value={Number(category3) || 0}
                                onChange={(e) =>
                                  setCategory3(Number(e.target.value))
                                }
                                disabled={
                                  !dataDropdownCategories3?.categoriesParent
                                    ?.length
                                }
                                className="block w-full rounded-md border-0 py-1.5 text-gray-500 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:max-w-xs sm:text-sm sm:leading-6"
                              >
                                <option value={0}></option>
                                {dataDropdownCategories3?.categoriesParent?.map(
                                  (c) => (
                                    <option
                                      key={c.categoryID}
                                      value={c.categoryID}
                                    >
                                      {c.categoryName}
                                      {c.parentCategoryName
                                        ? ` / ${c.parentCategoryName}`
                                        : ""}
                                    </option>
                                  )
                                )}
                              </select> */}
                              <select
                                id="category3"
                                name="category3"
                                value={Number(category3) || 0}
                                onChange={(e) =>
                                  setCategory3(Number(e.target.value))
                                }
                                disabled={
                                  !category2 || cat3Options.length === 0
                                }
                                className="block w-full rounded-md border-0 py-1.5 text-gray-500 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:max-w-xs sm:text-sm sm:leading-6"
                              >
                                <option value={0}></option>
                                {cat3Options.map((c) => (
                                  <option
                                    key={c.categoryID}
                                    value={c.categoryID}
                                  >
                                    {c.categoryName}
                                    {c.parentCategoryName
                                      ? ` / ${c.parentCategoryName}`
                                      : ""}
                                  </option>
                                ))}
                              </select>
                            </div>

                            <div className="flex items-center gap-4">
                              <label
                                htmlFor="max"
                                className="w-40 text-sm font-medium text-gray-600"
                              >
                                Low Point
                              </label>
                              <input
                                type="text"
                                name="lowPoint"
                                id="lowPoint"
                                value={lowPoint ? lowPoint : ""}
                                onChange={(e) => {
                                  setLowPoint(e.target.value);
                                }}
                                className="block w-full rounded-md border-0 py-1.5 text-gray-500 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                              />
                            </div>

                            <div className="flex items-center gap-4">
                              <label
                                htmlFor="typePiece"
                                className="w-40 text-sm font-medium text-gray-600"
                              >
                                Type Piece
                              </label>
                              <select
                                id="typePiece"
                                name="typePiece"
                                onChange={(e) => setTypePiece(e.target.value)}
                                className="block w-full rounded-md border-0 py-1.5 text-gray-500 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:max-w-xs sm:text-sm sm:leading-6"
                              >
                                <option value={props.typePieceID}>
                                  {props.typePiece}
                                </option>

                                {dataTypePiece?.typePieces?.map((item) => (
                                  <option
                                    key={item.typePieceID}
                                    value={item.typePieceID}
                                  >
                                    {item.typePiece}
                                  </option>
                                ))}
                              </select>
                            </div>

                            <div className="flex items-center gap-4">
                              <label
                                htmlFor="lowPoint2"
                                className="w-40 text-sm font-medium text-gray-600"
                              >
                                Low Point 2
                              </label>
                              <input
                                type="text"
                                name="lowPoint2"
                                id="lowPoint2"
                                value={lowPoint2 ? lowPoint2 : ""}
                                onChange={(e) => {
                                  setLowPoint2(e.target.value);
                                }}
                                className="block w-full rounded-md border-0 py-1.5 text-gray-500 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                              />
                            </div>

                            <div className="flex items-center gap-4">
                              <label className="relative w-40">
                                <input
                                  type="checkbox"
                                  className="hidden peer"
                                />
                                {"Locations (+/-)"}

                                {dataLocations.status !== "success" ? null : (
                                  <div className="absolute bg-white border transition-opacity opacity-0 pointer-events-none peer-checked:opacity-100 peer-checked:pointer-events-auto">
                                    <ul className="grid grid-cols-3 w-64">
                                      {dataLocations.locations.map(
                                        (option, i) => {
                                          return (
                                            <li
                                              className="mr-15"
                                              key={option + i}
                                            >
                                              <label className="flex whitespace-nowrap cursor-pointer px-1 py-1 transition-colors hover:bg-blue-100 [&:has(input:checked)]:bg-blue-200">
                                                {getCheckedLocation(
                                                  option.name,
                                                ) ? (
                                                  <input
                                                    type="checkbox"
                                                    name="locations"
                                                    value={option.name}
                                                    checked
                                                    onChange={() => {
                                                      addRemoveLocation(
                                                        option.name,
                                                      );
                                                    }}
                                                    className="cursor-pointer"
                                                  />
                                                ) : (
                                                  <input
                                                    type="checkbox"
                                                    name="locations"
                                                    value={option.name}
                                                    onChange={() => {
                                                      addRemoveLocation(
                                                        option.name,
                                                      );
                                                    }}
                                                    className="cursor-pointer"
                                                  />
                                                )}

                                                <span className="ml-1 text-xs font-medium">
                                                  {option.name}
                                                </span>
                                              </label>
                                            </li>
                                          );
                                        },
                                      )}
                                    </ul>
                                  </div>
                                )}
                              </label>
                              <input
                                type="text"
                                name="defaultLocation"
                                id="defaultLocation"
                                value={
                                  locations?.length > 0
                                    ? locations
                                    : defaultLocation
                                }
                                onChange={(e) => {
                                  setDefaultLocation(e.target.value);
                                }}
                                className="block w-full rounded-md border-0 py-1.5 text-gray-500 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                              />
                            </div>

                            <div className="flex items-center gap-4">
                              <label
                                htmlFor="openOrders"
                                className="w-40 text-sm font-medium text-gray-600"
                              >
                                Open Orders
                              </label>
                              <input
                                type="text"
                                name="openOrders"
                                id="openOrders"
                                value={props.openOrders ?? ""}
                                disabled
                                className="block w-full bg-gray-200 rounded-md border-0 py-1.5 text-gray-500 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                              />
                            </div>

                            <div className="flex items-center gap-4">
                              <label
                                htmlFor="adminOnly"
                                className="w-40 text-sm font-medium text-gray-600"
                              >
                                Admin
                              </label>
                              <input
                                type="checkbox"
                                name="adminOnly"
                                id="adminOnly"
                                checked={adminOnly === 1 ? true : false}
                                onChange={(e) => {
                                  setAdminOnly(e.target.checked ? 1 : 0);
                                }}
                                className="block w-4 rounded-md border-0 py-1.5 text-gray-500 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                              />
                            </div>

                            <div className="flex items-center gap-4">
                              <label
                                htmlFor="available"
                                className="w-40 text-sm font-medium text-gray-600"
                              >
                                Available
                              </label>
                              <input
                                type="text"
                                name="available"
                                id="available"
                                value={props.available ?? ""}
                                disabled
                                className="bg-gray-200 block w-full rounded-md border-0 py-1.5 text-gray-500 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                              />
                            </div>

                            <div className="flex items-center gap-4">
                              <label
                                htmlFor="adminOnly"
                                className="w-40 text-sm font-medium text-gray-600"
                              >
                                Off Web
                              </label>
                              <input
                                type="checkbox"
                                name="offWeb"
                                id="offWeb"
                                checked={offWeb === 1 ? true : false}
                                onChange={(e) => {
                                  setOffWeb(e.target.checked ? 1 : 0);
                                }}
                                className="block w-4 rounded-md border-0 py-1.5 text-gray-500 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                              />
                            </div>

                            <div className="flex items-center gap-4">
                              <label
                                htmlFor="qtyLastReceived"
                                className="w-40 text-sm font-medium text-gray-600"
                              >
                                Qty Last Received
                              </label>
                              <input
                                type="text"
                                name="qtyLastReceived"
                                id="qtyLastReceived"
                                value={props.qtyLastReceived ?? ""}
                                disabled
                                className="bg-gray-200 block w-full rounded-md border-0 py-1.5 text-gray-500 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                              />
                            </div>

                            <div className="flex items-center gap-4">
                              <label
                                htmlFor="dateLastReceived"
                                className="w-40 text-sm font-medium text-gray-600"
                              >
                                Date Last Received
                              </label>
                              <input
                                type="text"
                                name="dateLastReceived"
                                id="dateLastReceived"
                                value={formatDate(props.dateLastReceived) ?? ""}
                                disabled
                                className="bg-gray-200 block w-full rounded-md border-0 py-1.5 text-gray-500 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                              />
                            </div>
                          </div>
                        </form>

                        <form onSubmit={handleSubmit}>
                          <table className="min-w-full divide-y divide-gray-300 mt-10">
                            <tbody className="divide-gray-200">
                              {image && pending == false ? (
                                <>
                                  <tr
                                    onClick={() => {
                                      setImage("");
                                      setDeleteImage(true);
                                    }}
                                  >
                                    <td colSpan={2}>
                                      <div className="text-xs text-red-500 text-end hover:cursor-pointer mr-4">
                                        DELETE
                                      </div>
                                    </td>
                                  </tr>
                                  <tr>
                                    <td colSpan={2}>
                                      <img
                                        src={imageURL + image}
                                        className="h-full w-full object-cover object-center"
                                      />
                                    </td>
                                  </tr>
                                  <tr>
                                    <td colSpan={2}>
                                      {/* <div className="text-xs w-full">
                                        {image ? image : ""}
                                      </div>
                                      <div className="text-xs w-full">
                                        {image ? image.split("-").pop() : ""}
                                      </div> */}
                                      <div className="text-xs w-full">
                                        {image
                                          ? image.replace(/^[^-]+-/, "")
                                          : ""}
                                      </div>
                                    </td>
                                  </tr>
                                </>
                              ) : null}
                              <tr>
                                <td>
                                  {" "}
                                  <label
                                    htmlFor="image"
                                    className="block text-sm font-medium leading-6 text-gray-900 sm:pt-1.5"
                                  >
                                    Update Image?
                                  </label>
                                </td>
                                <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                                  <input
                                    type="file"
                                    name="image"
                                    id="image"
                                    accept="image/*,.pdf"
                                    onChange={(event) => {
                                      setImage(event.target.files[0]);
                                      setPending(true);
                                    }}
                                  />
                                </td>
                              </tr>

                              {image2 && pending2 == false ? (
                                <>
                                  <tr
                                    onClick={() => {
                                      setImage2("");
                                      setDeleteImage2(true);
                                    }}
                                  >
                                    <td colSpan={2}>
                                      <div className="text-xs text-red-500 text-end hover:cursor-pointer mr-4">
                                        DELETE
                                      </div>
                                    </td>
                                  </tr>
                                  <tr>
                                    <td colSpan={2}>
                                      {/* <img
                                        src={imageURL + image2}
                                        className="h-full w-full object-cover object-center"
                                      /> */}

                                      <object
                                        data={imageURL + image2}
                                        type="application/pdf"
                                        width="100%"
                                        height="100%"
                                      ></object>
                                    </td>
                                  </tr>
                                  <tr>
                                    <td colSpan={2}>
                                      <div className="text-xs w-full">
                                        {image2
                                          ? image2.replace(/^(?:[^-]+-){2}/, "")
                                          : ""}
                                      </div>
                                    </td>
                                  </tr>
                                </>
                              ) : null}
                              <tr>
                                <td className="w-[60%]">
                                  {" "}
                                  <label
                                    htmlFor="image2"
                                    className="block text-sm font-medium leading-6 text-gray-900 sm:pt-1.5"
                                  >
                                    Update Image2?
                                  </label>
                                </td>
                                <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                                  <input
                                    type="file"
                                    name="image2"
                                    id="image2"
                                    accept="image/*,.pdf"
                                    onChange={(event) => {
                                      setImage2(event.target.files[0]);
                                      setPending2(true);
                                    }}
                                  />
                                </td>
                              </tr>
                            </tbody>
                          </table>
                          <div className="mt-3">
                            <button
                              type="submit"
                              className="flex items-center justify-center rounded-md border border-transparent bg-amber-600 px-6 py-3 text-base font-medium text-white shadow-sm hover:bg-amber-700"
                            >
                              Edit Item
                            </button>
                          </div>
                        </form>
                      </div>
                    </div>
                  </Dialog.Panel>
                </Transition.Child>
              </div>
            </div>
          </div>
        </Dialog>
      </Transition.Root>
    );
  }
}
